import { FC } from 'react';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';
import { ICON_COLLECTION } from '../constants/icon';

/** 作废按钮 */
const InvalidButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

InvalidButton.defaultProps = {
  icon: ICON_COLLECTION.INVALID,
  text: '作废',
};

export default InvalidButton;
